// @flow
import React from "react";
import styles from "./index.module.css";

const defaultCustomDom = <div className={styles.error}>404</div>;

const Component404 = ({ customDom = defaultCustomDom }) => {
  return <div className={styles.wrapper}>{customDom}</div>;
};

export default Component404;
